import React from "react";

const MapPin = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0007 10.4166C11.3814 10.4166 12.5007 9.29734 12.5007 7.91663C12.5007 6.53591 11.3814 5.41663 10.0007 5.41663C8.61994 5.41663 7.50065 6.53591 7.50065 7.91663C7.50065 9.29734 8.61994 10.4166 10.0007 10.4166Z"
        stroke="#CBCDD1"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.0007 18.3333C11.6673 15 16.6673 12.8485 16.6673 8.33329C16.6673 4.65139 13.6825 1.66663 10.0007 1.66663C6.31875 1.66663 3.33398 4.65139 3.33398 8.33329C3.33398 12.8485 8.33398 15 10.0007 18.3333Z"
        stroke="#CBCDD1"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default MapPin;
